module.exports = __webpack_public_path__ + "28f21917bb64c747c202a72bf2d46555.jpg";